const ExposedIpIcon = () => {
  return (
    <svg
                width={25}
                height={25}
                viewBox="0 0 25 25"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  fillRule="evenodd"
                  clipRule="evenodd"
                  d="M21.0938 4.6875H3.90625C3.47478 4.6875 3.125 5.03728 3.125 5.46875V17.1875H21.875V5.46875C21.875 5.03728 21.5252 4.6875 21.0938 4.6875ZM3.90625 3.125C2.61183 3.125 1.5625 4.17433 1.5625 5.46875V18.75H23.4375V5.46875C23.4375 4.17433 22.3882 3.125 21.0938 3.125H3.90625Z"
                  fill="#0EC9AC"
                />
                <path
                  d="M0 18.75H25V19.5312C25 20.8257 23.9507 21.875 22.6562 21.875H2.34375C1.04933 21.875 0 20.8257 0 19.5312V18.75Z"
                  fill="#0EC9AC"
                />
              </svg>
  )
}

export default ExposedIpIcon